namespace GeniuzPOS.Administration {
    export interface UnlockUserResponse extends Serenity.ServiceResponse {
        Inserted?: number;
        Updated?: number;
        ErrorList?: string[];
    }
}
